import "./goalscorers.sass";

export default function Goalscorers({ 
  homeScorers = [],
  awayScorers = [],
  homeTeamName = "Local",
  awayTeamName = "Visitante",
}) {
  // Componente para renderizar un goleador
  const ScorerItem = ({ scorer, position }) => (
    <div key={scorer.player_id} className="scorer-row">
      <div className="scorer-position">
        <span className="position-number">{position}</span>
      </div>

      <div className="scorer-info">
        <div className="scorer-name">{scorer.name}</div>
      </div>

      <div className="scorer-stats">
        <div className="stat stat--goals">
          <span className="stat-label">Goles</span>
          <span className="stat-value">{scorer.goals}</span>
        </div>

        <div className="stat stat--appearances">
          <span className="stat-label">PJ</span>
          <span className="stat-value">{scorer.appearances}</span>
        </div>

        <div className="stat stat--average">
          <span className="stat-label">Promedio</span>
          <span className="stat-value">
            {(scorer.goals / scorer.appearances).toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );

  if (homeScorers.length === 0 && awayScorers.length === 0) {
    return (
      <div className="goalscorers-container">
        <div className="empty-message">No hay goleadores disponibles</div>
      </div>
    );
  }

  return (
    <div className="goalscorers-container">
      <div className="goalscorers-wrapper">
        {/* Equipo Local */}
        <div className="goalscorers-team goalscorers-team--home">
          <div className="team-header">
            <h3 className="team-title">{homeTeamName}</h3>
          </div>
          <div className="goalscorers-content">
            {homeScorers.length === 0 ? (
              <div className="empty-team-message">Sin goleadores</div>
            ) : (
              homeScorers.map((scorer, index) => (
                <ScorerItem key={scorer.player_id} scorer={scorer} position={index + 1} />
              ))
            )}
          </div>
        </div>

        {/* Equipo Visitante */}
        <div className="goalscorers-team goalscorers-team--away">
          <div className="team-header">
            <h3 className="team-title">{awayTeamName}</h3>
          </div>
          <div className="goalscorers-content">
            {awayScorers.length === 0 ? (
              <div className="empty-team-message">Sin goleadores</div>
            ) : (
              awayScorers.map((scorer, index) => (
                <ScorerItem key={scorer.player_id} scorer={scorer} position={index + 1} />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
